import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ConfirmationModal, MenuItem, Select, TextField } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useRestfulWrapper } from '~/hooks/useRestfulWrapper';
import { useUpdateRelationship } from '~/hooks/useUpdateRelationship';
import { useLocaleKeys } from '~/i18n';
import { agreementChangeModel, relationshipSummaryModel } from '~/models';
function AssigneeField(props) {
    const { members, sellerUserId, setSellerUserId } = props;
    const { t: texts } = useLocaleKeys('pages.agreementsDashboard.changeAssigneeModal');
    const options = useMemo(()=>members.filter((m)=>m.isAssignable(true)).map((m)=>({
                value: m.id(),
                label: m.fullName()
            })), [
        members
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        bi: {
            name: 'change_assignee'
        },
        collapseHelperText: false,
        testId: "select-assignee",
        label: texts.assigneeLabel(),
        value: sellerUserId,
        menuMaxHeight: 400,
        onChange: (e)=>setSellerUserId(e.target.value),
        children: options.map((param)=>{
            let { value, label } = param;
            return /*#__PURE__*/ _jsx(MenuItem, {
                value: value,
                testId: "select-assignee-option-".concat(value),
                children: label
            }, value);
        })
    });
}
export default function ChangeAssigneeModal(props) {
    const { relationship, dismissModal, onSuccess } = props;
    const { t: texts } = useLocaleKeys('pages.agreementsDashboard.changeAssigneeModal');
    const { api } = useStoreActions();
    const updateRelationship = useUpdateRelationship();
    const { loading, data, renderRestfulState } = useRestfulWrapper({
        fetch: ()=>Promise.all([
                api.member.getAll(),
                api.relationship.get(relationship.id)
            ])
    });
    const [sellerUserId, setSellerUserId] = useState(relationshipSummaryModel.sellerId(relationship));
    async function changeAssignee() {
        if (!data) return;
        updateRelationship({
            id: relationship.id,
            version: data[1].version,
            changes: [
                agreementChangeModel.makeSellerChange(sellerUserId)
            ],
            onSuccess: async ()=>{
                await onSuccess();
                dismissModal();
            }
        });
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'change_assignee_confirm'
            },
            secondaryButton: {
                name: 'change_assignee_cancel'
            }
        },
        title: texts.title(),
        testId: "change-assignee-modal",
        textAlignCenter: false,
        primaryButtonLabel: texts.save(),
        secondaryButtonLabel: texts.cancel(),
        primaryButtonDisabled: loading,
        onPrimaryButtonClick: changeAssignee,
        onSecondaryButtonClick: ()=>dismissModal(),
        content: renderRestfulState({
            renderChild: (param)=>{
                let { data } = param;
                return /*#__PURE__*/ _jsx(AssigneeField, {
                    members: data[0].members,
                    sellerUserId: sellerUserId,
                    setSellerUserId: setSellerUserId
                });
            },
            renderLoader: ()=>/*#__PURE__*/ _jsx(TextField, {
                    bi: {
                        name: 'assignee_loading_placeholder'
                    },
                    collapseHelperText: false,
                    testId: "select-assignee-placeholder",
                    label: texts.assigneeLabel(),
                    value: texts.loading()
                })
        })
    });
}
